import React from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import TrainIcon from "../../assets/icons/RADARIA-ICONO21.png";
import StartIcon from "../../assets/icons/RADARIA-ICONO13.png";
import FireIcon from "../../assets/icons/RADARIA-ICONO05.png";
import MapIcon from "../../assets/icons/RADARIA-ICONO41.png";
import StartLigthIcon from "../../assets/icons/RADARIA-ICONO29.png";
import { handleError } from "../../utils/handleError";
import toast from "react-hot-toast";
import { BenefitItem } from "./BenefitItem";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { fetchNewSessionPayment } from "../../services/rest/membership/membershipService";

const ModalPerformancePack = ({ open, setOpen, membership, setLoading }) => {
  const onClose = () => {
    setOpen(false);
  };
  const { _id, userType, status } = useSelector((state) => state.userReducer);
  const { isAuthenticated } = useSelector((state) => state.authReducer);
  const navigate = useNavigate();
  const handlePaymentLink = async () => {
    try {
      setLoading(true);
      const response = await fetchNewSessionPayment({
        membershipType: membership?.planName,
        userId: _id,
      });
      response?.url && window.open(response?.url, "_blank");
      setLoading(false);
    } catch (error) {
      const { message } = handleError(error);
      setLoading(false);
      toast.error(`En este momento no podemos generar su pago. \n ${message}`);
    }
  };
  const handleClick = async () => {
    try {
      if (!isAuthenticated) {
        toast.error(
          "Inicia sesión o crea una cuenta para poder adquirir una membresía."
        );
        return;
      }
      if (status !== "active") {
        toast.error("Complete su cuenta para poder adquirir una membresía.");
        return;
      }

      if (userType === "user") {
        console.log("Membresia seleccionada Card Landing", membership);
        setLoading(true);
        await handlePaymentLink();

        navigate("/dashboard/account", {
          state: {
            paymentStatus: true, // Indica si hay link de pago activo
          },
        });
      } else {
        toast.error("Inicia sesión como Runner.");
      }
    } catch (error) {
      const { message } = handleError(error);
      // setLoading(false);
      toast.error(`En este momento no podemos generar su pago. \n ${message}`);
    }
  };
  return (
    <Dialog
      open={open}
      onClose={() => onClose(false)}
      maxWidth="sm"
      fullWidth
      fullScreen={false}
      scroll="paper"
    >
      <DialogTitle
        variant="h4"
        sx={{
          fontWeight: "bold",

          color: "#e7ef7d",
          textAlign: "center",
        }}
      >
        Con Radaria Performance Pack tendrás:
      </DialogTitle>
      <DialogContent dividers style={{ padding: "20px" }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            width: "100%",
          }}
        >
          <Box sx={{ p: 3 }}>
            {/* Beneficio 1 - Entrenamiento */}
            <BenefitItem
              icon={
                <img src={TrainIcon} alt="Icono de entrenamiento." width={40} />
              }
              title="Entrenamiento personalizado."
              description="Entrenamiento mensual para corredores, completamente personalizado:"
              features={[
                "Asesoría virtual mensual personalizada.",
                "Plan de entrenamiento adaptado a tus objetivos y necesidades.",
                "Seguimiento continuo por WhatsApp.",
              ]}
              sx={{ mb: 3 }}
            />

            {/* Beneficio 2 - Nutrición */}
            <BenefitItem
              icon={
                <img
                  src={StartLigthIcon}
                  alt="Icono de entrenamiento."
                  width={40}
                />
              }
              title="Consulta nutricional."
              description="Una consulta nutricional al mes, presencial o virtual:"
              features={[
                "Análisis de composición corporal.",
                "Plan de alimentación según tus metas y entrenamiento.",
                "Seguimiento nutricional por WhatsApp.",
              ]}
              sx={{ mb: 3 }}
            />

            {/* Beneficio 3 - Fisioterapia */}
            <BenefitItem
              icon={
                <img src={FireIcon} alt="Icono de entrenamiento." width={40} />
              }
              title="Sesión de fisioterapia."
              description="Una sesión de fisioterapia al mes para tu bienestar físico:"
              features={[
                "Masaje de descarga muscular.",
                "Asesoría de prevención de lesiones.",
                "Rehabilitación física cuando lo necesites.",
              ]}
              sx={{ mb: 3 }}
            />

            {/* Beneficio 4 - Rutas */}
            <BenefitItem
              icon={
                <img src={MapIcon} alt="Icono de entrenamiento." width={40} />
              }
              title="Rutas personalizadas."
              description="Recomendaciones adaptadas a tus necesidades:"
              features={[
                "Rutas según la distancia que quieras recorrer.",
                "Sugerencias de terrenos según tu nivel.",
                "Planificación de progresión en distancias.",
              ]}
              sx={{ mb: 3 }}
            />

            {/* Beneficio 5 - Eventos */}
            <BenefitItem
              icon={
                <img
                  src={StartIcon}
                  alt="Icono de entrenamiento."
                  width={40}
                  height={40}
                />
              }
              title="Acceso a eventos de runners."
              description="Conecta con la comunidad runner:"
              features={[
                "Eventos mensuales exclusivos para miembros.",
                "Conoce a otros corredores con tus mismos intereses.",
                "Participa en carreras organizadas por Radaria.",
              ]}
            />
          </Box>
        </Box>
      </DialogContent>
      <DialogActions sx={{ display: "flex", justifyContent: "space-between" }}>
        <Typography sx={{ ml: 8 }} variant="h4">
          ${membership?.price}
        </Typography>
        <Button
          variant="contained"
          className={`btn ${"btn-primary"} btn-membership me-3 ms-3 mb-2`}
          sx={{ backgroundColor: "#e7ef7d" }}
          onClick={() => handleClick()}
        >
          Elegir Plan
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalPerformancePack;
